"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layouts = _interopRequireDefault(require("../layouts"));
var _default = _interopRequireDefault(require("../layouts/default"));
var _cccisdFooter = _interopRequireDefault(require("cccisd-footer"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppHeader = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/deployment\/AppHeader\/index\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return null;
}();
var AppFooter = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/deployment\/AppFooter\/index\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return null;
}();
var PlayerLayout = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function PlayerLayout() {
    var _this;
    _classCallCheck(this, PlayerLayout);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlayerLayout, [].concat(args));
    _defineProperty(_this, "state", {
      /**
       * Course Wrapper needs to toggle background color depending on tab
       * Usually, first tab is Description with no background, so this
       * prevents the flicker effect of showing bg initially and taking it away
       */
      isShowingLayoutBgColor: _this.props.navigation && _this.props.navigation.startsWith('courseWrapper') ? false : true
    });
    _defineProperty(_this, "setIsShowingLayoutBgColor", function (bool) {
      if (_this.state.isShowingLayoutBgColor !== bool) {
        _this.setState({
          isShowingLayoutBgColor: bool
        });
      }
    });
    return _this;
  }
  _inherits(PlayerLayout, _React$Component);
  return _createClass(PlayerLayout, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        showHeader = _this$props.showHeader,
        showFooter = _this$props.showFooter,
        frameHandle = _this$props.frameHandle,
        settings = _this$props.settings;
      var currentLayout = _layouts["default"].find(function (item) {
        return item.handle === frameHandle;
      }) || _default["default"];
      var LayoutComponent = currentLayout.component;

      // need to pass setIsShowingBackground through children to the mediator
      var children = _react["default"].Children.map(this.props.children, function (child) {
        if (/*#__PURE__*/_react["default"].isValidElement(child)) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            setIsShowingLayoutBgColor: _this2.setIsShowingLayoutBgColor,
            currentLayout: _objectSpread(_objectSpread({}, currentLayout), {}, {
              settings: settings
            })
          });
        }
        return child;
      });
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.DefaultPlayerSettingsContext.Provider, {
        value: currentLayout.flowPlayerSettings
      }, /*#__PURE__*/_react["default"].createElement(LayoutComponent, {
        showHeader: showHeader,
        showFooter: showFooter,
        header: AppHeader && /*#__PURE__*/_react["default"].createElement(AppHeader, null),
        footer: AppFooter && /*#__PURE__*/_react["default"].createElement(AppFooter, null) || /*#__PURE__*/_react["default"].createElement(_cccisdFooter["default"], null),
        settings: settings,
        isShowingLayoutBgColor: this.state.isShowingLayoutBgColor
      }, children));
    }
  }]);
}(_react["default"].Component);
_defineProperty(PlayerLayout, "propTypes", {
  /** Should we show the header? */
  showHeader: _propTypes["default"].bool,
  /** Should we show the header? */
  showFooter: _propTypes["default"].bool,
  /** The handle of the background to use */
  frameHandle: _propTypes["default"].string,
  settings: _propTypes["default"].object,
  navigation: _propTypes["default"].string,
  children: _propTypes["default"].node
});